import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Uso de chats especialistas para apoio na resolução de problemas.",
    correct: true,
  },
  {
    option: "b) Acompanhamento do código-fonte.",
    correct: false,
  },
  {
    option: "c) Gestão de pipelines de CI/CD.",
    correct: false,
  },
  {
    option: "d) Análise automática de código.",
    correct: false,
  },
  {
    option: "e) Monitoramento em tempo real do desempenho da aplicação.",
    correct: false,
  },
];

export default function Question3(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question3: {
          title: "Selecione um dos benefícios do uso do Agiliza.Ai",
          option: option.option,
          correct: option.correct,
          order: 3
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Selecione um dos benefícios do uso do Agiliza.Ai")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
